import React from "react";
import { useShallow } from "zustand/react/shallow";
import useStoreRoom from "store/useStoreRoom";
import useStoreRoomPlayer from "store/useStoreRoomPlayer";
import Opponent, { RoomSeat } from "./Entity/Opponent";
import Player from "./Entity/Player";

const SEATS_BY_PLAYER_COUNT: Record<number, RoomSeat[]> = {
    2: ["top", "bottom-left", "left", "top-left", "top-right", "right", "bottom-right"],
    3: ["top-left", "top", "bottom-left", "left", "top-right", "right", "bottom-right"],
    4: ["top-left", "top", "top-right", "bottom-left", "left", "right", "bottom-right"],
    5: ["left", "top-left", "top", "top-right", "bottom-left", "right", "bottom-right"],
};

const DEFAULT_SEATS: RoomSeat[] = [
    "bottom-left",
    "left",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
];

const SPECTATOR_SEATS: RoomSeat[] = [...DEFAULT_SEATS, "bottom"];

const RoomPlayersContainer = () => {
    const room = useStoreRoom(useShallow(state => ({ players: state.room?.players })));
    const roomPlayer = useStoreRoomPlayer(useShallow(state => state.roomPlayer));
    const isSpectator = !roomPlayer;

    const myPositionInCurrentRoomPlayers = React.useMemo(() => room?.players?.findIndex(x => x.player.id === roomPlayer?.player.id), [room?.players, roomPlayer?.player.id]);

    const myRoomPlayersView = React.useMemo(() => {
        if(!room?.players) {
            return [];
        }

        if(isSpectator) {
            return room.players;
        }

        const others = room.players.filter(player => player.player.id !== roomPlayer.player.id);
        return [...others.slice(myPositionInCurrentRoomPlayers || 0), ...others.slice(0, myPositionInCurrentRoomPlayers || 0)];
    }, [room?.players, myPositionInCurrentRoomPlayers, roomPlayer, isSpectator]);

    if(!room?.players) {
        return null;
    }

    const seats = isSpectator
        ? SPECTATOR_SEATS
        : SEATS_BY_PLAYER_COUNT[room.players.length] ?? DEFAULT_SEATS;

    return (
        <>
            {roomPlayer && <Player roomPlayer={roomPlayer} />}

            <div>
                {Array.from({ length: isSpectator ? 8 : 7 }).map((_, index) => (
                    <Opponent
                        key={index}
                        roomPlayer={myRoomPlayersView[index] ?? null}
                        seat={seats[index]}
                    />
                ))}
            </div>
        </>
    )
}

export default RoomPlayersContainer;
